import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, filter, map, Observable, of, tap } from 'rxjs';
import { DataInputOption, InfoDialogComponent } from '@trivelope/triv-ui-tools-lib';
import { Environment } from '../classes/environment';
import { MyFile } from '../classes/fileInfo';
import { News, NewsBackend, Rubric, RubricBackend } from '../classes/news';
import { CurrentUserService } from './current-user.service';


@Injectable({ providedIn: 'root' })
export class NewsService {

	private rubricCache: Rubric[] = [];


	constructor(
		@Inject('environment') private environment: Environment,
		private httpClient: HttpClient,
		private matSnackBar: MatSnackBar,
		private matDialog: MatDialog,
		@Inject('LOCALSTORAGE') private localStorage: Storage,
		private currentUserService: CurrentUserService,
	) {
		/*
		for( let i = 0; i < 10; i++ ) {
			const rubric = new Rubric();
			rubric.id = "" + i;
			rubric.name = "Rubric " + i;
			this.rubricCache.push( rubric );
		}

		for( let i = 0; i < 10; i++ ) {
			const news = new News();
			news.id = "" + ( 666 + i );
			let rndString = "";
			const chars = " abcdefg";
			for( let i = 0; i < 20 + Math.ceil(Math.random()*50); i++ ) {
				rndString += chars[ Math.floor(Math.random()*chars.length) ];
			}
			news.title = "Title " + i + " " + rndString;
			news.rubrics = i == 0 ? [ "" + i] : [ "0", "" + i ];
			news.contactTitle = "Herr";
			news.contactFirstName = "John";
			news.contactFamilyName = "Müller";
			news.contactPhone = "0123456";
			news.contactEmail = "test@test.test";

			const b = !!(i%2);
			if( b ) {
				news.url = "http://trivelope.de";
			}
			else {
				news.content = `<h1>Hello</h1><p>This is rich text. <span style='color:red'>RED?!</span>.</p>
					<p><code>code block</code></p>
<strong><span style="background-color:#d4c5f9;">Lorem Ipsum</span></strong>
<span style="background-color:#d4c5f9;">&nbsp;is simply dummy text of the printing and typesetting industry. </span>
<em><span style="background-color:#d4c5f9;">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</span></em>
<span style="background-color:#d4c5f9;">, when an unknown p</span>rinter took a galley of type and scrambled it to make a type specimen book.
				`;

				if( i%4 ) {

					news.content = `<p>
Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis id maximus purus. Nam fringilla, orci ut porttitor finibus, nisi leo gravida ligula, vitae eleifend augue diam et ligula. Fusce a malesuada est. Aliquam hendrerit tincidunt libero. Vestibulum quis accumsan erat, in vehicula leo. Sed eget ultricies felis. Ut eget ante vel nulla volutpat feugiat. Maecenas vitae risus semper, varius ligula id, tempus nisi. Pellentesque est sapien, tempor non malesuada ut, commodo eu massa. Aenean fermentum dui eros. Maecenas eget pretium diam. Curabitur et suscipit tellus. Aenean convallis leo vitae velit volutpat, eget blandit ipsum dapibus.
</p>
<p>
Suspendisse sed dictum sem. Ut vehicula dui eget lacus tempor tristique. Morbi orci sem, euismod vitae felis nec, eleifend sagittis nibh. Morbi in purus lacus. Maecenas leo nisl, aliquam et tincidunt vitae, dictum pharetra elit. Sed tempor finibus cursus. Ut lacinia libero eu sapien rutrum, ac ultricies mauris convallis. Duis eget dui tortor. Suspendisse sed convallis magna. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae;
</p>
<p>
Sed pulvinar et est at placerat. Nullam maximus augue non leo tincidunt ultrices. Donec et viverra eros, ac tempus dui. Proin ac enim facilisis, laoreet ante at, pharetra tellus. Proin viverra cursus tortor eu imperdiet. Nam quis libero ornare, placerat elit ut, maximus odio. Donec sit amet sem nisi. Cras laoreet quis nisi a bibendum. Proin fermentum in nisi sit amet feugiat. Pellentesque varius enim orci, vehicula ultricies elit maximus hendrerit. Curabitur posuere magna eget egestas ullamcorper. Proin sollicitudin vulputate lectus, non tincidunt nibh fermentum eget. Nunc pellentesque diam id eros mattis vehicula.
</p>
<p>
Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Quisque nisi felis, feugiat non posuere sit amet, consequat at lectus. Phasellus at velit pharetra, imperdiet ante maximus, finibus lectus. Sed quis lacus vitae nulla luctus placerat quis ut mauris. Fusce et volutpat nibh. Curabitur non lectus eleifend, rutrum ipsum at, egestas mauris. Cras dolor ante, accumsan quis vehicula nec, feugiat facilisis augue.
</p>
<p>
Sed maximus nisi nisl, non eleifend ipsum rhoncus sit amet. In ac ipsum ac sem facilisis cursus vitae non nisl. Quisque pretium elit ut volutpat viverra. Pellentesque eleifend laoreet eros sit amet porttitor. Vestibulum dapibus tortor ac orci maximus suscipit nec sit amet velit. Aenean ac magna vel neque rhoncus luctus. Fusce in felis porta nunc vulputate tempor. Fusce laoreet dapibus eros sed hendrerit. Proin viverra neque eget massa venenatis laoreet. Phasellus quis pretium est. Sed efficitur lorem iaculis dui accumsan, sit amet feugiat dui gravida. Integer eleifend mauris id neque iaculis blandit.
</p>`;
				}
			}
			news.bReleased = true;
			this.newsCache.push( news );
		}
		*/

	}


	getRubrics(): Observable<Rubric[]> {

		return this.httpClient.get<RubricBackend[]>( this.environment.backendUrl + 'rubrik/all' ).pipe(

			map( rubrics => {
				if( !rubrics || !rubrics.length ) return [];
				this.rubricCache = rubrics.map( r => this.convertRubricBtoF(r) );
				return this.rubricCache;
			}),
			catchError( err => {
				this.matSnackBar.open( 'Beim Abrufen der Liste der Rubriken ist ein Fehler aufgetreten', 'Fehler' );
				return [];
			})

		);

	}

	private convertRubricBtoF( rubricB: RubricBackend ): Rubric {

		const rubric = new Rubric();
		rubric.id = rubricB.rubrikId;
		rubric.name = rubricB.rubrikName;
		rubric.active = rubricB.active;
		rubric.userSubscribable = !rubricB.special;
		return rubric;

	}

	isUniqueCalendarName( rubricId: string, name: string ): boolean {

		const newName = name.toLocaleLowerCase();
		return !this.rubricCache.find( rubric => ( rubric.name.toLocaleLowerCase() === newName ) && ( rubric.id != rubricId ) );

	}

	saveRubric( rubric: Rubric ): Observable<Rubric | null> {

		if( !this.isUniqueCalendarName( rubric.id, rubric.name ) ) {
			this.matDialog.open( InfoDialogComponent, {
				data: { title: "Fehler", message: "Eine Rubrik mit diesem Namen existiert bereits." }
			});
			return of(null);
		}


		return this.httpClient.post<RubricBackend>(
			this.environment.backendUrl + 'rubrik/save',
			this.convertRubricFtoB( rubric )
		).pipe(
			map( rubricBackend => {

				if( !rubricBackend || !rubricBackend.rubrikId ) return null;

				const savedRubric = this.convertRubricBtoF( rubricBackend );

				const oldRubric = this.rubricCache.find( r => r.id == savedRubric.id );
				if( oldRubric ) {
					oldRubric.name = savedRubric.name;
					oldRubric.active = savedRubric.active;
				}
				else this.rubricCache.push( savedRubric );

				return savedRubric;
			}),
			catchError( err => {
				this.matDialog.open( InfoDialogComponent, {
					data: { title: "Fehler", message: "Beim Speichern der Rubrik ist ein Fehler aufgetreten" }
				});
				return of(null);
			})
		);

	}

	private convertRubricFtoB( rubric: Rubric ): RubricBackend {

		const rubricB = new RubricBackend();
		rubricB.rubrikId = rubric.id;
		rubricB.rubrikName = rubric.name;
		rubricB.active = rubric.active;
		rubricB.special = !rubric.userSubscribable;
		return rubricB;

	}



	deleteRubric( id: string ): Observable<boolean> {

		/*
		const i = this.rubricCache.findIndex( r => r.id === id );
		if( i == -1 ) return of( false );

		this.rubricCache.splice( i, 1 );
		return of( true );
		*/

		return this.httpClient.delete<boolean>(
			this.environment.backendUrl + 'rubrik/delete/' + id
		).pipe(

			map( answer => !!answer ),
			catchError( err => {
				this.matDialog.open( InfoDialogComponent, {
					data: { title: "Fehler", message: "Beim Löschen der Rubrik ist ein Fehler aufgetreten" }
				});
				return of(false);
			})

		);

	}


	getNews(): Observable<News[]> {

		return this.httpClient.get<NewsBackend[]>( this.environment.backendUrl + 'nachrichten/all' ).pipe(

			map( news => {
				if( !news || !news.length ) return [];
				return news.map( n => this.convertNewsBtoF(n) );
			}),
			catchError( err => {
				this.matSnackBar.open( 'Beim Abrufen der Liste der Nachrichten ist ein Fehler aufgetreten', 'Fehler' );
				return [];
			})

		);

	}

	searchNews(
		text: string,
		days: number|null = null,
		year: number|null = null,
		startTms: number|null = null,
		endTms: number|null = null,
		released: boolean|null = null,
		page=0
	)
	: Observable<{ news: News[], bMoreResults: boolean } | null> {

		let httpParams = new HttpParams()
			.set( "page", page )
			.set( "size", 100 );

		if( text ) httpParams = httpParams.set( "text", text );

		// Start & End Date are expected to be timestamps.
		// Jahr & Tage simple numbers.
		// Precedence in case multiple time parameters: start & end date > jahr > tage
		if( days ) httpParams = httpParams.set( "tage", days );
		if( year ) httpParams = httpParams.set( "jahr", year );
		if( startTms !== null ) httpParams = httpParams.set( "startDatum", startTms );
		if( endTms !== null ) httpParams = httpParams.set( "endDatum", endTms );

		if( released !== null ) httpParams = httpParams.set( "freigabe", released )


		return this.httpClient.get<{ content: NewsBackend[], totalPages: number }>(
			this.environment.backendUrl + 'nachrichten/search',
			{ params: httpParams }
		).pipe(

			map( pageNews => {

				if( !pageNews || !pageNews.content ) return null;
				return {
					news: pageNews.content.map( n => this.convertNewsBtoF(n) ),
					bMoreResults: (pageNews.totalPages > (page+1))
				};

			}),
			catchError( err => {
				this.matSnackBar.open( 'Beim Abrufen der Nachrichten ist ein Fehler aufgetreten', 'Fehler' );
				return of(null);
			})

		);

	}

	private convertNewsBtoF( newsB: NewsBackend ): News {

		const news = new News();
		news.creationTms = newsB.erstellungsDatum || null;
		news.bReleased = !!newsB.freigabe;
		news.categories = newsB.kategorieIds || [];
		news.contactTitle = newsB.kontaktAnrede || "";
		news.contactEmail = newsB.kontaktEmail || "";
		news.contactFirstName = newsB.kontaktVorname || "";
		news.contactFamilyName = newsB.kontaktName || "";
		news.contactPhone = newsB.kontaktTelephonNr || "";
		news.id = newsB.nachrichtenId || "";
		news.content = newsB.nachrichtenInhalt || "";
		news.title = newsB.titel || "";
		news.url = newsB.url || "";
		if( news.url ) {
			const url = news.url.toLocaleLowerCase();
			if( !url.startsWith( "http://" ) && !url.startsWith( "https://" ) ) {
				news.url = "https://" + newsB.url;
			}
		}
		news.rubrics = newsB.rubrikIds || [];
		if( newsB.dateien && newsB.dateien.length ) {
			for( const fileInfo of newsB.dateien ) {
				const myFile = new MyFile();
				myFile.id = fileInfo.dateiId;
				myFile.file = new File( [], fileInfo.dateiName );
				myFile.percentageUploaded = 100;
				news.myFiles.push( myFile );
			}
		}

		const currentUser = this.currentUserService.currentUser();
		news.bSeen = !!( currentUser && currentUser.ebeLetzterLogin && news.creationTms && (news.creationTms < currentUser.ebeLetzterLogin) );
		return news;

	}


	saveNews( news: News ): Observable<string> {

		return this.httpClient.post<NewsBackend>(
			this.environment.backendUrl + 'nachrichten/save',
			this.convertNewsFtoB( news )
		).pipe(

			map( answer => {
				if( !answer || !answer.nachrichtenId ) return "";
				return answer.nachrichtenId;
			}),
			catchError( err => {
				this.matDialog.open( InfoDialogComponent, {
					data: { title: "Fehler", message: "Beim Speichern der Nachricht ist ein Fehler aufgetreten" }
				});
				return of("");
			})

		);

	}


	publishNews( newsId: string ): Observable<boolean> {

		return this.httpClient.post<{ verarbeitet: boolean }>(
			this.environment.backendUrl + 'nachrichten/release/' + newsId,
			{}
		).pipe(

			map( answer => {
				if( !answer || !answer.verarbeitet ) return false;
				return true;
			}),
			catchError( err => {
				this.matDialog.open( InfoDialogComponent, {
					data: { title: "Fehler", message: "Beim Freigeben der Nachricht ist ein Fehler aufgetreten" }
				});
				return of(false);
			})

		);

	}


	private convertNewsFtoB( news: News ): NewsBackend {

		const newsB = new NewsBackend();
		newsB.erstellungsDatum = news.creationTms;
		newsB.freigabe = news.bReleased;
		newsB.kategorieIds = news.categories;
		newsB.rubrikIds = news.rubrics;
		newsB.kontaktAnrede = news.contactTitle;
		newsB.kontaktEmail = news.contactEmail;
		newsB.kontaktVorname = news.contactFirstName;
		newsB.kontaktName = news.contactFamilyName;
		newsB.kontaktTelephonNr = news.contactPhone;
		newsB.nachrichtenId = news.id;
		newsB.nachrichtenInhalt = news.content;
		newsB.titel = news.title;
		newsB.url = news.url;
	delete newsB.dateien;
		return newsB;

	}


	deleteNews( news: News ): Observable<boolean> {

		return this.httpClient.delete<boolean>(
			this.environment.backendUrl + 'nachrichten/delete',
			{ body: this.convertNewsFtoB( news ) }
		).pipe(

			map( answer => !!answer ),
			catchError( err => {
				this.matDialog.open( InfoDialogComponent, {
					data: { title: "Fehler", message: "Beim Löschen der Nachricht ist ein Fehler aufgetreten" }
				});
				return of(false);
			})

		);

	}

	subscribeUserToRubrics( userId: string, rubricIds: string[] ): Observable<boolean> {

		return this.httpClient.post<string>(
			this.environment.backendUrl + 'rubrik/subscribe',
			{ ebeId: userId, rubrikIds: rubricIds },
		).pipe(
			map( answer => {
				if( !answer ) return false;
				return true;
			} ),
			catchError( err => {
				this.matDialog.open( InfoDialogComponent, {
					data: { title: "Fehler", message: "Beim Zuweisen von Gruppen ist ein Fehler aufgetreten" }
				});
				return of(false);
			})
		);

	}

	getRubricsSubscribedToUser( userId: string ): Observable<string[]|null> {

		return this.httpClient.get<RubricBackend[]>(
			this.environment.backendUrl + 'rubrik/subscribedRubriken/' + userId,
		).pipe(
			map( rubrics => {
				if( !rubrics || !rubrics.length ) return [];
				return rubrics.map( rubric => rubric.rubrikId );
			} ),
			catchError( err => of(null) )
		);

	}

	getStoredSubscribedRubrics(): string[] {

		const rubricIds: string[] = [];
		const str = this.localStorage.getItem( "subscribedRubrics" );
		if( str && str.length ) {
			try {
				const arr = JSON.parse( str );
				for( const id of arr ) rubricIds.push( id );
			}
			catch( e ) {}
		}
		return rubricIds;

	}

	storeSubscribedRubrics( ids: string[] ) {
		this.localStorage.setItem( 'subscribedRubrics', JSON.stringify( ids ) );
	}

}


